import React from "react";
import { FaTrash } from "react-icons/fa";
import ConfirmButton from "../common/ConfirmButton";

interface DeleteButtonProps {
    onConfirm: (e?: React.MouseEvent) => void;
    confirmText: string;
    className?: string;
    disabled?: boolean;
}

const DeleteButton = ({ onConfirm, confirmText, className = "", disabled = false }: DeleteButtonProps) => {
    return (
        <ConfirmButton
            className={`min-w-fit px-2 ${className}`}
            content={<FaTrash className="text-red-500 cursor-pointer" />}
            confirmText={confirmText}
            onConfirm={onConfirm}
            disabled={disabled}
        />
    );
};

export default DeleteButton;
